import {useEffect} from "react";
import {Text, usePatronTheme, View} from "@unibuddy/patron";
import {IconInformationCircle} from "@unibuddy/icons";
import {useAnalytics} from "@unibuddy/tracking";
import {TrackEvents} from "ubcommunity-shared/src/constants";
import {useEmailInvite} from "../EmailInviteProvider/EmailInviteProvider";

export enum SignupInvitedEmailPromptStrings {
    Title = "Make sure you use this email, even if you sign up with Google or Apple",
}

export const SignupInvitedEmailPrompt = () => {
    const theme = usePatronTheme();
    const {trackEvent} = useAnalytics();
    const {invitedEmail} = useEmailInvite();

    useEffect(() => {
        if (invitedEmail) {
            trackEvent(TrackEvents.SIGNUP_INVITED_EMAIL_PROMPT_SHOWN);
        }
    }, [trackEvent, invitedEmail]);

    if (!invitedEmail) return;

    return (
        <View
            w="100%"
            paddingX="xsmall"
            paddingY="small"
            borderRadius="xxsmall"
            bgColor="blue50"
            // @ts-ignore - "accessible" is valid in Native
            accessible
            accessibilityRole="alert"
            flexDirection="row"
            gap="xsmall"
            alignItems="center"
        >
            <View flexShrink={0}>
                <IconInformationCircle color={theme?.colors?.blue600} width={24} height={24} />
            </View>
            <Text color="blue600">{SignupInvitedEmailPromptStrings.Title}</Text>
        </View>
    );
};
